/**
 * Reads the host application of a Catalog AiTool (`spec.application`, spread onto the
 * tool by the BFF's `/ai-tools` route).
 *
 * The type definition declares it as `{ name }`, but older items carry a bare string
 * (`"mia-flow"`), and the AI Foundry website rewrites it to the object form on every
 * save. Both shapes are live at once, so a strict `=== 'mia-flow'` would silently drop
 * every tool that has been migrated or edited from Foundry.
 */

export const MIA_FLOW_APPLICATION = 'mia-flow'

export const toolApplicationName = (tool) => {
  const application = tool?.application
  if (typeof application === 'string') { return application }
  if (application !== null && typeof application === 'object' && typeof application.name === 'string') {
    return application.name
  }
  return undefined
}

export const isMiaFlowTool = (tool) => toolApplicationName(tool) === MIA_FLOW_APPLICATION
